module.exports = __webpack_public_path__ + "img/r_hone_icon_07.240d48a5.png";